import React, { useState } from "react";
import { getLocationByName, updateLocation } from "../../../ruleService";
import { showDangerToast, showSuccessToast } from "../../../../validation/ToastContainer";
import { hasErrors } from "../../../../utils";
import { connect } from "react-redux";
import LocationNameField from "./LocationNameField";
import TargetTypeWizardModal from "../TargetTypeWizardModal";

function EditLocationModal({ setShowModal, validationErrors, selectedLocation }) {

    const [location, setLocation] = useState(selectedLocation);

    const onSaveClick = async () => {

        const serverLocation = await getLocationByName(location.name);
        let savedLocation;

        if ((serverLocation.error && serverLocation.statusCode === 404) || serverLocation.id === location.id) {
            savedLocation = await updateLocation(location);
        } else {
            showDangerToast(`Location with name '${location.name}' already exist`, "Save Location")
        }

        if (savedLocation) {
            showSuccessToast("Location updated", "Save Location");
            setShowModal(false);
        }

    }

    return (
        <TargetTypeWizardModal
            title="Edit Location Wizard"
            subtitle="Update the selected location target type."
            onClose={() => setShowModal(false)}
            onSubmit={onSaveClick}
            submitLabel="Update"
            submitDisabled={hasErrors(validationErrors)}
            contentClassName="target-type-wizard-form__content--compact"
        >
            <LocationNameField location={location} setLocation={setLocation} />
        </TargetTypeWizardModal>
    );

}

function mapStateToProps(state) {
    return {
        validationErrors: state.validation
    }
}

export default connect(mapStateToProps)(EditLocationModal);
